import getCompanyIdForRequest from '../getCompanyIdForRequest.js';

const getPusherAuthHeaders = (bearerToken) => {
  const companyId = getCompanyIdForRequest();
  return {
    Authorization: `Bearer ${bearerToken}`,
    ...(companyId ? { 'X-Company-Id': companyId } : {})
  };
};

export default getPusherAuthHeaders;
